var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#F3F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8123 26V14.8H21.6203V26H19.8123ZM17.5723 16.448V14.8H21.4603V16.448H17.5723Z",
    fill: "#008CB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileStep1);
export default __webpack_public_path__ + "static/media/mobile-step1.197f741b31d618ca14e2816dd226e2f7.svg";
export { ForwardRef as ReactComponent };